const PIN_STATUS = Object.freeze({
  active: 'active',
  inactive: 'deleted',
});

// noinspection JSUnusedGlobalSymbols
export default PIN_STATUS;
